/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { httpClient } from "../request";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { statusToIcon } from "../status";
import "./Register.css";

export default function Register(properties) {
  const [validated, setValidated] = useState(false);

  const [state, setState] = useState({
    developer: "",
    license: "",
    result: {
      status: "",
      message: "",
    },
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleRenew = (e) => {
    const form = e.currentTarget;

    const isValid = form.checkValidity();

    e.preventDefault();
    e.stopPropagation();

    setValidated(true);

    if (!isValid) return;

    const data = {
      developer: state.developer,
      license: state.license,
    };

    httpClient
      .post("/private/renew", null, {
        params: data,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setState({
            developer: "",
            license: "",
            result: {
              status: "success",
              message: "Successfully renewed account",
            },
          });
        } else {
          setState({
            developer: "",
            license: "",
            result: {
              status: "danger",
              message: "An unexpected error has occurred",
            },
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          const responseData = error.response.data;

          if ("error" in responseData) {
            // Catch edge cases, usually happens with network errors
            setState({
              developer: "",
              license: "",
              result: {
                status: "danger",
                message: responseData.error,
              },
            });
          } else {
            // Catch edge cases, usually happens with network errors
            setState({
              developer: "",
              license: "",
              result: {
                status: "danger",
                message: error.message,
              },
            });
          }
        }
      });
  };

  return (
    <div className="Renew">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-4 mx-auto">
            {state.result && (
              <Alert variant={state.result.status}>
                <span className="mr-1">
                  <FontAwesomeIcon icon={statusToIcon[state.result.status]} />
                </span>
                <span>{state.result.message}</span>
              </Alert>
            )}

            <Form noValidate validated={validated} onSubmit={handleRenew}>
              <Form.Group controlId="developer">
                <Form.Label>Developer username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter developer username"
                  value={state.developer}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a username
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="license">
                <Form.Label>License</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter license"
                  value={state.license}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a license
                </Form.Control.Feedback>
              </Form.Group>

              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Renew.js